<template>
    <div>

    </div>
</template>

<script>
    import {client as http} from "@/http_client";

    export default {
        props: ['id'],
        methods: {
            lookup: function() {
                http.get('providers/finalforms/v1/lookup/' + this.$route.query.id + '/' + this.$route.query.email, {force: true}).then(response => {
                    localStorage.setItem('wiaa_id', this.$route.query.id);
                    if (response.data.email) {
                        localStorage.setItem('remember', JSON.stringify({email: response.data.email}));
                        if (this.$route.query.code) {
                            this.$router.push('/?code=' + this.$route.query.code);
                        } else {
                            this.$router.push('/');
                        }
                    } else {

                        let remember = {
                            wiaa_id: this.$route.query.id,
                            email: this.$route.query.email,
                            email_2: this.$route.query.secondary_email,
                            first_name: this.$route.query.first_name,
                            last_name: this.$route.query.last_name,
                            dob: this.$route.query.date_of_birth,
                            address: this.$route.query.street_address,
                            address_2: this.$route.query.address_2,
                            city: this.$route.query.city,
                            state: this.$route.query.state,
                            zip: this.$route.query.zip,
                            phone_2: (this.$route.query.work_phone) ? this.$route.query.work_phone.replace(/[^0-9]/g, '').replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3') : null,
                            phone: (this.$route.query.cell_phone) ? this.$route.query.cell_phone.replace(/[^0-9]/g, '').replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3') : null,
                            district: this.$route.query.school_district,
                            referral: 'FinalForms/WIAA'
                        };

                        localStorage.setItem('remember', JSON.stringify(remember));
                        this.$router.push('/signup');
                    }
                }).catch(err => {
                    if (err) console.log(err);
                });
            }
        },
        mounted() {
            if (this.$route.query.code) {
                console.log('Redirect to a code...');
                http.get('app/courses/new/code/' + this.$route.query.code, {force: true}).then(response => {
                    localStorage.setItem('redirectTo', '/course-catalog?code=' + response.data.code + '&course=' + response.data.id);
                    this.lookup();
                }).catch(err => {
                    if (err.response.status === 404) {
                        window.alert('The course you are requesting may no longer be available. If you need additional help please contact us at support@my247ed.com.');
                    } else {
                        window.alert('An error occurred. If you need additional help please contact us at support@my247ed.com.');
                    }
                    this.lookup();
                });
            } else {
                http.get('providers/finalforms/v1/lookup/cert/' + this.id, {force: true}).then(response => {
                    // a conference is providing for this cert
                    if (response.data) {
                        console.log('Redirect to a conf...');
                        this.$router.push('/register/' + response.data);
                    } else {
                        console.log('Redirect to a cert...');
                        localStorage.setItem('redirectTo', '/course-catalog?cert=' + this.id);
                        this.lookup();
                    }
                });
            }
        }
    };
</script>

<style scoped>

</style>
